import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ItemsService {

  private readonly url = 'iam-invoice/sellers';

  constructor(private http: HttpClient) {
  }

  get(): Observable<any> {
    return this.http.get(`${this.url}/self`);
  }

  getBusinessTypes(): Observable<any> {
    return this.http.get(`iam-common/business-types`);
  }

  set(item: any): Observable<any> {
    return this.http.put(`${this.url}/self`, item);
  }

  toggleDecreeCircular(): Observable<any> {
    return this.http.put(`${this.url}/toggle-decree-circular`, {});
  }

  getChangelogs(lazyLoadEvent: string): Observable<any> {
    return this.http.get(`${this.url}/changing-log?lazyLoadEvent=${lazyLoadEvent}`);
  }

  getConsumeReview(): Observable<any> {
    return this.http.get(`${this.url}/consume-review`);
  }
  getProductList(): Observable<any> {
    return this.http.get(`iam-sales/customer-request/products`);
  }
  initPayment(data:any): Observable<any> {
    return this.http.post(`/iam-sales/customer-request/init-napas`,data);
  }
  getRequestList(lazyLoadEvent: string,params?: any): Observable<any> {
    return this.http.get(`iam-invoice/requests/list?lazyLoadEvent=${lazyLoadEvent}`, {params});
  }

  getMessage100Accepted(): Observable<any> {
    return this.http.get(`${this.url}/message-100-accepted`);
  }

  getNotifications(): Observable<any> {
    return this.http.get(`/iam-common/notifications`);
  }

  getCount(): Observable<any> {
    return this.http.get(`/iam-common/notifications/count`);
  }

  markTouched(): Observable<any> {
    return this.http.put(`/iam-common/notifications/mark`, {});
  }

  getBanks(): Observable<any> {
    return this.http.get(`iam-system/banks`);
  }

}
